import React from 'react';
import Layout from 'layouts/manager/Layout';

// ダミー差分データ
const diffData = {
  model: '店舗情報',
  diff:[
    { type: 'unchanged', value: '店舗名: 東京本店' },
    { type: 'removed', value: '住所: 東京都千代田区1-1-1' },
    { type: 'added', value: '住所: 東京都千代田区2-2-2' },
    { type: 'unchanged', value: '電話番号: 03-1234-5678' },
    { type: 'removed', value: '担当者: 佐藤花子' },
    { type: 'added', value: '担当者: 山田太郎' },
  ]
};

const typeStyle = {
  unchanged: 'bg-white',
  added: 'bg-green-50 text-green-800 border-l-4 border-green-400',
  removed: 'bg-red-50 text-red-800 border-l-4 border-red-400',
};

const typePrefix = {
  unchanged: ' ',
  added: '+',
  removed: '-',
};

const Diff: React.FC = () => {
  return (
    <Layout>
      <div className="mx-auto">
        <h1 className="mb-3 text-lg font-bold text-gray-800">更新内容</h1>
        <div className="p-4 bg-white border rounded shadow">
          <div className="mb-3">
            <a href="/manager/update-history" className="text-sm text-gray-500 underline transition hover:text-gray-700">&lt; 一覧画面に戻る</a>
          </div>
          <h2 className="mb-1 text-lg font-bold text-gray-800">{diffData.model}</h2>
          <hr className="mb-4 border-gray-200" />
          <ul className="font-mono text-sm divide-y divide-gray-100">
            {diffData.diff.map((line, idx) => (
              <li
                key={idx}
                className={`flex items-center px-2 py-1 whitespace-pre ${typeStyle[line.type]}`}
              >
                <span className="w-5 text-center select-none">
                  {typePrefix[line.type]}
                </span>
                <span>{line.value}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Layout>
  );
};

export default Diff;
